module.exports = __webpack_public_path__ + "img/register1.34875d22.svg";